import { render } from "./BuildingsAndFloorPlans.vue?vue&type=template&id=09201b64&scoped=true&ts=true"
import script from "./BuildingsAndFloorPlans.vue?vue&type=script&lang=ts"
export * from "./BuildingsAndFloorPlans.vue?vue&type=script&lang=ts"

import "./BuildingsAndFloorPlans.vue?vue&type=style&index=0&id=09201b64&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09201b64"]])

export default __exports__